import { useState } from 'react'
import { I18n } from 'react-polyglot'
import { useAsync } from 'react-use'

export interface LanguageProviderProps {
  children: JSX.Element
  locale: string
}

const LanguageProvider = ({ children, locale }: LanguageProviderProps) => {
  const [languageFile, setLanguageFile] = useState<JSON>()

  useAsync(async () => {
    // Lazy import of the translations based on the locale
    const langFile = await Promise.all([
      import(`@ucc/unified-admin-common/output/translations/${locale || 'en_US'}.json`),
      import(`translations/${locale || 'en_US'}.json`),
    ]).then((values) => ({
      ...values[0],
      ...values[1],
    }))

    setLanguageFile(langFile)
  }, [locale])

  return languageFile ? (
    <I18n locale={locale} messages={languageFile}>
      {children}
    </I18n>
  ) : null
}

export default LanguageProvider
